import {
  trans, WEBHOOKS_FILTERS_FIELD_CATEGORIES, WEBHOOKS_FILTERS_FIELD_PRIORITIES,
  WEBHOOKS_FILTERS_FIELD_STATUSES, WEBHOOKS_FILTERS_FIELD_TEAMS, WEBHOOKS_FILTERS_FIELD_RESOLUTIONS,
  WEBHOOKS_FILTERS_RECORD_SINGULAR_ISSUE, WEBHOOKS_FILTERS_RECORD_SINGULAR_NOTE,
  WEBHOOKS_FILTERS_RECORD_SINGULAR_CHECKLIST, WEBHOOKS_FILTERS_RECORD_PLURAL_ISSUE,
  WEBHOOKS_FILTERS_RECORD_PLURAL_NOTE, WEBHOOKS_FILTERS_RECORD_PLURAL_CHECKLIST,
  WEBHOOKS_FILTERS_RECORD_ARTICLE_ISSUE, WEBHOOKS_FILTERS_RECORD_ARTICLE_NOTE,
  WEBHOOKS_FILTERS_RECORD_ARTICLE_CHECKLIST, WEBHOOKS_FILTERS_SUMMARY_MORE_VALUES,
  WEBHOOKS_FILTERS_SUMMARY_FIELD, WEBHOOKS_FILTERS_SUMMARY_ALL_EVENTS
} from '../../translator'
import { EventFilters, IssueFilterOptions, fieldsFor, optionByIdForEvent } from './webhook-filter-options'

export function fieldLabel (field: string): string {
  switch (field) {
    case 'categories': return trans(WEBHOOKS_FILTERS_FIELD_CATEGORIES, {}, 'integrations')
    case 'priorities': return trans(WEBHOOKS_FILTERS_FIELD_PRIORITIES, {}, 'integrations')
    case 'statuses': return trans(WEBHOOKS_FILTERS_FIELD_STATUSES, {}, 'integrations')
    case 'teams': return trans(WEBHOOKS_FILTERS_FIELD_TEAMS, {}, 'integrations')
    case 'resolutions': return trans(WEBHOOKS_FILTERS_FIELD_RESOLUTIONS, {}, 'integrations')
    default: return field
  }
}

export function recordWord (recordType: string, form: 'singular' | 'plural' | 'article'): string {
  const words = {
    singular: { issue: WEBHOOKS_FILTERS_RECORD_SINGULAR_ISSUE, note: WEBHOOKS_FILTERS_RECORD_SINGULAR_NOTE, checklist: WEBHOOKS_FILTERS_RECORD_SINGULAR_CHECKLIST },
    plural: { issue: WEBHOOKS_FILTERS_RECORD_PLURAL_ISSUE, note: WEBHOOKS_FILTERS_RECORD_PLURAL_NOTE, checklist: WEBHOOKS_FILTERS_RECORD_PLURAL_CHECKLIST },
    article: { issue: WEBHOOKS_FILTERS_RECORD_ARTICLE_ISSUE, note: WEBHOOKS_FILTERS_RECORD_ARTICLE_NOTE, checklist: WEBHOOKS_FILTERS_RECORD_ARTICLE_CHECKLIST }
  }
  const key = recordType === 'issue' || recordType === 'note' ? recordType : 'checklist'
  return trans(words[form][key], {}, 'integrations')
}

export function summaryFor (eventType: string, filters: EventFilters, options: IssueFilterOptions): string {
  const parts = fieldsFor(eventType)
    .map((field) => {
      const selected = filters[eventType]?.[field] ?? []
      if (selected.length === 0) {
        return null
      }
      const first = optionByIdForEvent(options, field, selected[0].id, eventType)?.path ?? selected[0].id
      const values = selected.length > 1
        ? `${first} ${trans(WEBHOOKS_FILTERS_SUMMARY_MORE_VALUES, { '%count%': String(selected.length - 1) }, 'integrations')}`
        : first
      return trans(WEBHOOKS_FILTERS_SUMMARY_FIELD, { '%field%': fieldLabel(field), '%values%': values }, 'integrations')
    })
    .filter((part): part is string => part !== null)

  return parts.length > 0 ? parts.join(' · ') : trans(WEBHOOKS_FILTERS_SUMMARY_ALL_EVENTS, {}, 'integrations')
}
